<template>
  <div class="footer-father-container">
    <div class="footer-father">
      <!-- 底部联系信息卡片 -->
      <div class="bottom_contact_section">
        <p>{{ $t("Contacts Us") }}</p>
        <div class="bottom_contact_content">
          <h2>{{ $t("We'd Love To Hear From You") }}</h2>
          <div class="bottom_contact_card">
            <div class="contact_item">
              <img src="../../../static/img/footer_email_icon.png" class="contact-icon"/>
              <div>
                <p class="label">{{ $t("E-MAIL") }}</p>
                <p class="value">{{ displayEmail }}</p>
              </div>
            </div>
            <div class="contact_item contact_item_right">
              <img src="../../../static/img/footer_tel_icon.png" class="contact-icon"/>
              <div>
                <p class="label">{{ $t("TEL") }}</p>
                <p class="value">{{ displayPhone }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-top">
        <img src="../../../static/img/logo2.png"/>
      </div>
      <div class="nav_footer">
        <div class="footer-desc-wrapper">
          <p class="footer-desc">{{
              $i18n.locale === 'zh' ? contactData.subTitleCn : $i18n.locale === 'es' ? contactData.subTitleEs : contactData.subTitleEn
            }}</p>
          <div class="social-icons">
            <el-popover
                placement="top"
                trigger="click"
                width="120"
                popper-class="wx-qrcode-popover"
                :disabled="!currentWxQrcodeImage"
            >
              <img
                  v-if="currentWxQrcodeImage"
                  :src="currentWxQrcodeImage"
                  class="wx-qrcode-image"
              />
              <img
                  slot="reference"
                  src="../../../static/img/footer_wx_icon.png"
                  @mouseenter="$event.target.src = require('../../../static/img/footer_wx_icon_hover.png')"
                  @mouseleave="$event.target.src = require('../../../static/img/footer_wx_icon.png')"
                  class="social-icon"
              />
            </el-popover>
            <img
                src="../../../static/img/footer_wa_icon.png"
                @mouseenter="$event.target.src = require('../../../static/img/footer_wa_icon_hover.png')"
                @mouseleave="$event.target.src = require('../../../static/img/footer_wa_icon.png')"
                @click="jumpTo(contactData.waUrl)"
                class="social-icon"
            />
            <img
                src="../../../static/img/footer_fackbook_icon.png"
                @mouseenter="$event.target.src = require('../../../static/img/footer_fackbook_icon_hover.png')"
                @mouseleave="$event.target.src = require('../../../static/img/footer_fackbook_icon.png')"
                @click="jumpTo(contactData.fbUrl)"
                class="social-icon"
            />
            <img
                src="../../../static/img/footer_ins_icon.png"
                @mouseenter="$event.target.src = require('../../../static/img/footer_ins_icon_hover.png')"
                @mouseleave="$event.target.src = require('../../../static/img/footer_ins_icon.png')"
                @click="jumpTo(contactData.inUrl)"
                class="social-icon"
            />
          </div>
        </div>
        <div :class="$i18n.locale=== 'zh'||isMiniWindows  ? 'footer' : 'footer-big'">
          <div v-for="(item, i) in nav_title_list" :key="i" class="footer-sub">
            <div class="title-wrapper-f" @click="isMiniWindows ? toggleExpand(i) : navto(item.path)">
              <div class="title-wrapper">
                <p class="title">{{ item.title }}</p>
                <span v-if="isMiniWindows && item.children && item.children.length"
                      class="toggle-icon">
                  {{ expandedItems.includes(i) ? '−' : '+' }}
                </span>
              </div>
              <p
                  class="content"
                  :class="{ 'content-with-img': sub.img }"
                  v-for="sub in item.children"
                  :key="sub.title"
                  v-show="!isMiniWindows || expandedItems.includes(i)"
                  @click.stop="scrollNavto(i, sub.path, sub.tag)"
              >
                <img v-if="sub.img&&isMiniWindows" :src="sub.img" :alt="sub.title" class="sub-item-img"/>
                <span><span v-if="!isMiniWindows&&$i18n.locale==='es'" class="sub-item-icon">● </span>{{sub.title}}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="qrcode-div">
          <el-popover
              placement="top"
              trigger="click"
              width="120"
              popper-class="wx-qrcode-popover"
              :disabled="!currentWxQrcodeImage"
          >
            <img
                v-if="currentWxQrcodeImage"
                :src="currentWxQrcodeImage"
                class="wx-qrcode-image"
            />
            <img
                slot="reference"
                src="../../../static/img/footer_wx_icon.png"
                @mouseenter="$event.target.src = require('../../../static/img/footer_wx_icon_hover.png')"
                @mouseleave="$event.target.src = require('../../../static/img/footer_wx_icon.png')"
                class="social-icon"
            />
          </el-popover>
          <img
              src="../../../static/img/footer_wa_icon.png"
              @mouseenter="$event.target.src = require('../../../static/img/footer_wa_icon_hover.png')"
              @mouseleave="$event.target.src = require('../../../static/img/footer_wa_icon.png')"
              @click="jumpTo(contactData.waUrl)"
              class="social-icon"
          />
          <img
              src="../../../static/img/footer_fackbook_icon.png"
              @mouseenter="$event.target.src = require('../../../static/img/footer_fackbook_icon_hover.png')"
              @mouseleave="$event.target.src = require('../../../static/img/footer_fackbook_icon.png')"
              @click="jumpTo(contactData.fbUrl)"
              class="social-icon"
          />
          <img
              src="../../../static/img/footer_ins_icon.png"
              @mouseenter="$event.target.src = require('../../../static/img/footer_ins_icon_hover.png')"
              @mouseleave="$event.target.src = require('../../../static/img/footer_ins_icon.png')"
              @click="jumpTo(contactData.inUrl)"
              class="social-icon"
          />
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <p class="content" style="display: flex">
        {{ $t("版权所有") }}
        <a href="https://beian.miit.gov.cn/">浙ICP备2026021532号</a>
      </p>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/index";
import * as navBar from "./navbar";
import i18n from "../../main";

export default {
  data() {
    return {
      contact: [],
      product_list: [],
      member: [],
      activeQrcode: 0,
      contactData: {
        phoneCn: "",
        phoneEn: "",
        phoneEs: "",
        emailCn: "",
        emailEn: "",
        emailEs: "",
        addressCn: "",
        addressEn: "",
        addressEs: "",
        mapImage: "",
        topImage: "",
        topTitleCn: "",
        topTitleEn: "",
        topTitleEs: "",
        subTitleEn: "",
        subTitleCn: "",
        subTitleEs: "",
        wxUrlCn: "",
        wxUrlEn: "",
        wxUrlEs: "",
        waUrl: "",
        fbUrl: "",
        inUrl: ""
      },
      productTypeList: [],
      clientWidth: 0,
      isMiniWindows: false,
      expandedItems: []
    };
  },
  computed: {
    displayPhone() {
      return this.$getI18nField(this.contactData, "phone");
    },
    displayEmail() {
      return this.$getI18nField(this.contactData, "email");
    },
    currentWxQrcodeImage() {
      if (this.$i18n.locale === 'zh') {
        return this.contactData.wxUrlCn;
      }
      if (this.$i18n.locale === 'es') {
        return this.contactData.wxUrlEs;
      }
      return this.contactData.wxUrlEn;
    },
    nav_title_list() {
      const list = navBar.getList().filter(item => item.title !== i18n.t("首页") && item.title !== i18n.t("联系我们"));
      return list.map(item => {
        if (item.path === '/Products') {
          // const productChildren = (this.isMiniWindows ? this.productTypeList : this.productTypeList.slice(0, 3)).map(prod => ({
          const productChildren = this.productTypeList.map(prod => ({
            title: prod.title,
            path: prod.path,
            tag: prod.tag,
            img: prod.img
          }));
          // 添加 Other Optical Accessories
          // productChildren.push({
          //   title: i18n.t("其他产品"),
          //   path: '/Products',
          //   tag: 'Others',
          //   img: null
          // });
          return {...item, children: productChildren};
        }
        return {
          ...item,
          children: (item.children || []).map(({ img, blue_img, ...rest }) => rest)
        };
      });
    },
  },
  components: {},
  watch: {
    clientWidth(newVal) {
      this.isMiniWindows = newVal < 1200;
    },
  },
  mounted() {
    this.getContactUsData();
    this.getProductTypeList();
    this.Init();

    let that = this;
    var clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
    that.clientWidth = clientWidth;
    window.onresize = () => {
      return (() => {
        var clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
        that.clientWidth = clientWidth;
      })();
    };
  },

  methods: {
    // 获取联系我们信息
    getContactUsData() {
      API.getContactUsList({page: 1, limit: 1})
          .then((res) => {
            if (res.code === 0 && res.page && res.page.list && res.page.list.length > 0) {
              const data = res.page.list[0];
              this.contactData = {
                phoneCn: data.phoneCn || "",
                phoneEn: data.phoneEn || "",
                phoneEs: data.phoneEs || "",
                emailCn: data.emailCn || "",
                emailEn: data.emailEn || "",
                emailEs: data.emailEs || "",
                addressCn: data.addressCn || "",
                addressEn: data.addressEn || "",
                addressEs: data.addressEs || "",
                mapImage: data.mapImage || "",
                topImage: data.topImage || "",
                topTitleCn: data.topTitleCn || "",
                topTitleEn: data.topTitleEn || "",
                topTitleEs: data.topTitleEs || "",
                subTitleEn: data.subTitleEn || "",
                subTitleEs: data.subTitleEs || "",
                subTitleCn: data.subTitleCn || "",
                wxUrlCn: data.wxUrlCn || "",
                wxUrlEn: data.wxUrlEn || "",
                wxUrlEs: data.wxUrlEs || "",
                waUrl: data.waUrl || "",
                fbUrl: data.fbUrl || "",
                inUrl: data.inUrl || ""
              };
            }
          })
          .catch(() => {
          });
    },
    getProductTypeList() {
      API.getProductCategoryList()
          .then((res) => {
            console.log("getProductTypeList==" + JSON.stringify(res));
            if (res.code === 0 && res.page && res.page.list) {
              this.productTypeList = res.page.list.map(item => ({
                title: this.$getI18nField(item, 'title'),
                path: "/Products",
                tag: item.id,
                img: item.whiteImage,
                blue_img: item.blueImage,
              }));
            }
          })
          .catch((err) => {
            console.error("获取产品类型失败:", err);
          });
    },
    Init() {
      // this.getData();
      // this.getMember();
      // this.getTypeList();
    },
    getMember() {
      API.getMember()
          .then((res) => {
            var status = res.code;
            if (status === 0) {
              this.member = res.page.list;
            }
          })
          .catch(() => {
          });
    },
    getData() {
      API.getContacts()
          .then((res) => {
            console.log(res);
            var status = res.code;
            if (status === 0) {
              this.contact = res.data[0];
            }
          })
          .catch(() => {
          });
    },
    getTypeList() {
      API.getProductType()
          .then((res) => {
            var status = res.code;
            if (status === 0) {
              this.product_list = res.data;
              // this.nav_title_list[2].children = this.product_list;
            }
          })
          .catch(() => {
          });
    },
    qrcode(i) {
      this.activeQrcode = i;
    },
    navto(path) {
      if (path === '/Products' && this.$route.path === '/Products') {
        if (this.$route.query.param) {
          this.$router.push({ path: '/Products' }).catch(() => {});
        }
        return;
      }
      this.$router.push(path).catch(() => {});
    },
    jumpTo(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    handleCommand(command) {
      // this.$message("click on item " + command);
      this.jumpTo(command);
    },
    scrollNavto(index, path, name) {
      this.expandedItems = [];
      if (!name) {
        this.navto(path);
      } else {
        this.$router.push({
          path: `${path}`,
          query: {param: name},
        }).catch(() => {});
      }
    },
    toggleExpand(index) {
      const idx = this.expandedItems.indexOf(index);
      if (idx > -1) {
        this.expandedItems.splice(idx, 1);
      } else {
        this.expandedItems.push(index);
      }
    },
  },
  created() {
    // window.addEventListener("onmessageWS", this.addAnimatedIn);
  },
  destroyed() {
    // 移除事件监听
    window.removeEventListener("scroll", this.windowScrollListener);
  },
  updated() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.footer-father {
  background-image: linear-gradient(to bottom, rgba(29, 32, 135, 0), rgba(29, 32, 135, 0.9), rgba(29, 32, 135, 1)), url('../../../static/img/footer_bg.jpg');
  background-size: contain;
  background-repeat: no-repeat;
}

.footer-desc-wrapper {
  text-align: left;
}

.footer-desc {
  font-size: 1.6rem;
  line-height: 2rem;
  color: #E7E8EA;
  width: 35rem;
  text-align: left;
  font-family: light;
  margin-bottom: 8rem;
}

.social-icons {
  display: flex;
  gap: 3.5rem;
  align-items: center;
}

.social-icon {
  width: 3rem;
  height: 3rem;
  cursor: pointer;
  transition: opacity 0.3s;
}

.social-icon:hover {
  opacity: 0.8;
}

.qrcode-div {
  display: none;
}

.wx-qrcode-image {
  width: 120px;
  height: 150px;
  object-fit: contain;
  display: block;
}

@media screen and (max-width: 1200px) {
  .social-icons {
    display: none !important;
  }

  .qrcode-div {
    display: flex;
    gap: 2rem;
    align-items: center;
  }
}

.contact-icon {
  width: 5rem;
  height: 5rem;
}

.title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.toggle-icon {
  font-size: 2.4rem;
  color: #FFF;
  cursor: pointer;
  user-select: none;
  padding: 0 0.5rem;
}

.footer .footer-sub .title {
  font-size: 2.2rem;
  color: #9CCF86;
}

.footer-big .footer-sub .title {
  font-size: 2.2rem;
  color: #9CCF86;
}

.footer .footer-sub .content {
  font-size: 1.6rem;
  line-height: 3rem;
  color: #E8EFF7;
}
.footer-big .footer-sub .content {
  font-size: 1.6rem;
  line-height: 3rem;
  color: #E8EFF7;
}

.content-with-img {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.sub-item-img {
  width: 4rem;
  height: 4rem;
  object-fit: contain;
  flex-shrink: 0;
}
.sub-item-icon{
  font-size: 1.6rem;
  color:#9CCF86;
  line-height: 1.5;
  display: inline-block;
  transform: scale(0.5);
}

.footer .footer-sub + .footer-sub {
  //border-left: 1px solid #fff;
  padding-left: 2rem;
}
.footer-big .footer-sub + .footer-sub {
  //border-left: 1px solid #fff;
  padding-left: 2rem;
}

.footer-sub:last-child {
  margin-right: 0;
}

.bottom_contact_section {
  margin-bottom: 10rem;
}

.bottom_contact_section > p {
  font-size: 6rem;
  color: #fff;
  margin-top: 14.7rem;
  margin-bottom: 8rem;
  text-align: left;
  font-family: medium;
}

.bottom_contact_content h2 {
  font-size: 3.2rem;
  color: #1D2087;
  margin-top: 0;
  font-family: regular;
}

.bottom_contact_content {
  background: #fff;
  border-radius: 1.6rem;
  padding: 5rem 12rem;
  text-align: left;
}

.bottom_contact_card {
  display: flex;
  width: 100%;
}

.contact_item {
  display: flex;
  align-items: center;
  gap: 2rem;
  width: 50%;
}

.contact_item .label {
  margin: 0 0 0.5rem 0;
  font-size: 1.8rem;
  color: #212121;
  font-family: medium;
  text-align: left;
}

.contact_item .value {
  margin: 0;
  font-family: regular;
}

.contact_item_right {
  justify-content: flex-end;
  text-align: right;
}

.footer-bottom {
  border-top: 1px solid #fff;
  padding: 4rem 12.5% 4.5rem 12.5%;
}

.footer-bottom p {
  font-size: 1.6rem;
  font-family: light;
  color: #EDEDED;
  align-items: baseline;
}

@media screen and (max-width: 1200px) {
  .footer {
    flex-direction: column;
    gap: 3rem;
  }

  .footer-sub {
    width: 100% !important;
    margin-right: 0 !important;
  }

  .footer .footer-sub + .footer-sub {
    border-left: none;
    padding-left: 0;
    border-top: 1px solid #fff;
    padding-top: 2rem;
  }
  .footer-big .footer-sub + .footer-sub {
    border-left: none;
    padding-left: 0;
    border-top: 1px solid #fff;
    padding-top: 2rem;
  }

  .bottom_contact_section > p {
    font-size: 3.6rem;
    margin-top: 8rem;
    margin-bottom: 4rem;
  }

  .bottom_contact_content {
    padding: 3rem 2rem;
  }

  .bottom_contact_card {
    flex-direction: column;
    gap: 2rem;
  }

  .contact_item {
    width: 100%;
    justify-content: flex-start !important;
    text-align: left !important;
  }

  .footer-desc {
    width: 100%;
    margin-bottom: 4rem;
  }

  .social-icons {
    gap: 2rem;
  }
}

@media screen and (max-width: 768px) {
  .footer {
    max-width: 100% !important;
    gap: 2rem;
  }
  .footer-father {
    background-image: linear-gradient(to bottom, rgba(29, 32, 135, 0), rgba(29, 32, 135, 0.9), rgba(29, 32, 135, 1)), url('../../../static/img/footer_bg.png');
    padding: 2rem;
  }

  .bottom_contact_content {

    h2 {
      font-size: 2.2rem;
    }
  }

  .bottom_contact_section {
    margin-bottom: 5rem;
  }

  .contact_item {
    .label {
      font-size: 1.6rem;
    }

    .value {
      font-size: 1.6rem;
    }
  }

  .contact-icon {
    width: 4rem;
    height: 4rem;
  }

  .footer-top {
    img {
      height: 4rem;
    }
  }

  .footer-desc {
    font-size: 1.4rem;
  }

  .nav_footer {
    .title {
      margin-bottom: 0;
    }

    .footer-sub {
    }

  }
  .title-wrapper-f{
    width: 100%;

  }
  .title-wrapper {
    width: 100%;
    justify-content: space-between;
  }
  .footer .footer-sub .content{
    font-family: regular;
    font-size: 1.8rem;
  }
  .footer-bottom {
    padding: 2rem 2rem 3.5rem 2rem;

    p {
      font-size: 1.2rem;
      flex-direction: column;
    }

    a {
      margin-top: 1rem;
    }
  }
  .qrcode-div{
    margin-top: 3rem;
  }
}
</style>

<style lang="stylus">
.wx-qrcode-popover {
  width: 120px !important;
  min-width: 100px !important;
  padding: 0 !important;
}
</style>
